import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/site";

export const FAQ = ({ variant = "full" }) => {
  return (
    <section
      data-testid="faq-section"
      aria-labelledby="faq-heading"
      className={variant === "full" ? "py-20 md:py-28" : "py-16"}
    >
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center">
          <div className="text-xs uppercase tracking-[0.22em] font-semibold text-blue-700">
            Frequently Asked
          </div>
          <h2
            id="faq-heading"
            className="mt-4 font-serif text-3xl md:text-5xl leading-tight tracking-tight text-slate-900"
          >
            Clear answers to common questions.
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed">
            Simple, medically responsible answers about radiation oncology and
            cancer care.
          </p>
        </div>

        <div className="mt-12 bg-white rounded-3xl border border-slate-100 shadow-[0_20px_50px_-30px_rgba(30,58,138,0.2)] px-6 md:px-10 py-4">
          <Accordion type="single" collapsible className="divide-y divide-slate-100">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-b-0 py-2"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-serif text-lg md:text-xl text-slate-900 hover:text-blue-800 hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
